"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueOperation = void 0;
var resolveValue_1 = require("./resolveValue");
var valueOperation = function (structure, op) {
    var value = (0, resolveValue_1.resolveValue)(structure, op.value);
    return value;
};
exports.valueOperation = valueOperation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsdWVPcGVyYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ3JhcGgvdmFsdWVPcGVyYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsK0NBQThDO0FBRXZDLElBQU0sY0FBYyxHQUFHLFVBQzVCLFNBQXlCLEVBQ3pCLEVBQWtCO0lBRWxCLElBQU0sS0FBSyxHQUFHLElBQUEsMkJBQVksRUFBQyxTQUFTLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ2hELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQyxDQUFDO0FBTlcsUUFBQSxjQUFjLGtCQU16QiJ9